var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mySlot",attrs:{"href":_vm.url}},[_vm._t("button",[_c('a-button',[_vm._v("submit")])]),_vm._t("title",[_vm._v("\n        this is title\n    ")]),_vm._t("foot",[_vm._v("\n        this is foot\n    ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }